<template>
  <div class="avatar">
    <v-image
      v-if="url"
      class="avatar__image"
      :src="url"
    />
  </div>
</template>

<style lang="scss">
.avatar {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: map-get($colors, white);
  border-radius: 50%;
}
</style>

<script>
export default {
  name: 'Avatar',
  props: {
    url: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
